.imports {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-2);
}

/* Announces milestones only (front-door spec §6.1): read out, never seen */
.announcer {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.progress {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-1);
  align-self: stretch;
}

.result {
  align-self: stretch;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

/* A history row: the name and status take the room, the action sits beside them and never on top */
.row {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.rowAction {
  flex: none;
  margin-left: auto;
}

.missing {
  margin: var(--tuna-spacing-1) 0 0;
  padding-inline-start: var(--tuna-spacing-3);
}

/* On a phone the primary action spans the width, and every target is at least 44px */
@media (max-width: 599.95px) {
  .primary {
    align-self: stretch;
  }

  .imports button {
    min-height: 44px;
  }

  /* The result's buttons go below its message rather than squeezing it into a column */
  .alert {
    flex-wrap: wrap;
  }

  .actions {
    flex-basis: 100%;
  }
}
